module.exports = __webpack_public_path__ + "img/icons.0748a4a8.svg";